import { toastSuccess } from 'components/common/toaster/toast';
import { logError } from 'core/services/common/logging/logger';
import { BookmarksApi } from 'services/ApiService/ServiceBoard/ServiceBoardApi';
import { BookmarkOrigin, CreateBookmarkDto } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';
import { ThunkResult } from 'store/store';
import {
    createBookmarkFetchRequestAction,
    createBookmarkFetchSuccessAction,
    createBookmarkFetchFailureAction,
    createBookmarkCreateRequestAction,
    createBookmarkCreateSuccessAction,
    createBookmarkCreateFailureAction,
    createBookmarkDeleteRequestAction,
    createBookmarkDeleteSuccessAction,
    createBookmarkDeleteFailureAction,
} from './bookmarkAction';

export const getUserBookmarks = (): ThunkResult => {
    return async (dispatch) => {
        dispatch(createBookmarkFetchRequestAction());
        try {
            const bookmarks = await BookmarksApi.getUserBookmarks();
            dispatch(createBookmarkFetchSuccessAction(bookmarks?.bookmarks ?? []));
        } catch (error: unknown) {
            logError(error);
            dispatch(createBookmarkFetchFailureAction());
        }
    };
};

export const createUserBookmark = (referenceId: Nullable<string>, origin: Nullable<BookmarkOrigin>): ThunkResult => {
    return async (
        dispatch, _state, { translate },
    ) => {
        dispatch(createBookmarkCreateRequestAction());
        try {
            const request = { referenceId, origin } as CreateBookmarkDto;
            const bookmarkCreated = await BookmarksApi.createUserBookmark(request);
            toastSuccess(translate?.('bookmark:addToBookmarkToaster', { title: bookmarkCreated?.title ?? '' }));
            dispatch(createBookmarkCreateSuccessAction(bookmarkCreated));
        } catch (error: unknown) {
            logError(error);
            dispatch(createBookmarkCreateFailureAction());
        }
    };
};

export const deleteUserBookmark = (id: number): ThunkResult => {
    return async (dispatch, state, { translate }) => {
        dispatch(createBookmarkDeleteRequestAction());
        try {
            await BookmarksApi.deleteBookmark(id);
            const title = state().bookmark?.items?.filter(e => e.id === id)[0]?.title ?? '';
            toastSuccess(translate?.('bookmark:removeBookmarkToaster', { title }));
            dispatch(createBookmarkDeleteSuccessAction(id));
        } catch (error: unknown) {
            logError(error);
            dispatch(createBookmarkDeleteFailureAction());
        }
    };
};